export const SHOW_MODAL = '@trybeapp/component/AddCalendarEventOverlay/SHOW_MODAL'
